import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSkipPrevious$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSkipPrevious extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c8743329c08159be9bf33ad65d164ae1d294e835', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f2337a0786b31a9aae1f4ce032bb0be8608ac6f9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b1b1043a685189516d4e94b9aacfceed6808b4c9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zm10.614 13.336-6.455-6.443a.565.565 0 0 1 0-.786l6.455-6.443a.553.553 0 0 1 .786 0l.387.387a.565.565 0 0 1 0 .786l-5.668 5.658 5.668 5.668a.565.565 0 0 1 0 .786l-.387.387a.553.553 0 0 1-.786 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-skip-previous", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-skip-previous"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-skip-previous":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSkipPrevious$1);
            }
            break;
    } });
}

const CosmosIconSkipPrevious = CosmosIconSkipPrevious$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSkipPrevious, defineCustomElement };
